import { render, staticRenderFns } from "./tabMBL2UICustomLayout.vue?vue&type=template&id=46844eae&"
import script from "./tabMBL2UICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabMBL2UICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46844eae')) {
      api.createRecord('46844eae', component.options)
    } else {
      api.reload('46844eae', component.options)
    }
    module.hot.accept("./tabMBL2UICustomLayout.vue?vue&type=template&id=46844eae&", function () {
      api.rerender('46844eae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL2UICustomLayout.vue"
export default component.exports